import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {DietaryIndicatorData} from "./dietary-indicator.data";

@Injectable()
export class DietaryIndicatorEntityModel extends EntityModel<DietaryIndicatorData> {
    constructor(injector: Injector) {
        super(injector, DietaryIndicatorData)
    }
}
